const DayOffset = ({ days }) => {
    
    let firtDayOfMonthIndex = parseInt(days[0].getDay() - 1) === -1 ? 6 : parseInt(days[0].getDay() - 1);

    return (
        <>
            {Array.from({ length: firtDayOfMonthIndex }, (_, i) => (
                <div key={i}></div>
            ))}
        </>
    );
};

export default DayOffset;
